// extracted by mini-css-extract-plugin
module.exports = {"simpleList":"simpleList-module--simpleList--2M3p0","title":"simpleList-module--title--3RT5f","list":"simpleList-module--list--kmhay","item":"simpleList-module--item--nLZpk"};